import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ParentAPIService} from "../parent.api.service";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ApiValidation} from "../../model/api/api-validation";
import {Observable} from "rxjs";
import {CrystalclearArchiveBackUrl} from "../config/crystalclear-archive-back-url";
import {ReportTask} from "../../model/archive/report-task";
import {ApiFileResponse} from "../../model/api/api-file-response";
import {ReportTaskLoadRequest} from "../../model/archive/report-task-load-request";
import {CrystalclearClearingBackUrl} from "../config/crystalclear-clearing-back-url";
import {AllocationTask} from "../../model/clearing/allocation/allocation-task";
import {AllocationTaskLoadRequest} from "../../model/clearing/allocation/allocation-task-load-request";
import {SimpleRequest} from "../../model/api/simple-request";

@Injectable({
  providedIn: 'root'
})
export class ClearingAllocationTaskService extends ParentAPIService implements OnInit, OnDestroy {


  constructor(http: HttpClient) {
    super(http);
  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
  }

  public list(request: AllocationTaskLoadRequest): Observable<TableRecordResult<AllocationTask>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_TASK_LIST, request);
  }

  public check(taskId: string): Observable<ApiValidation<AllocationTask>> {
    return this.post(CrystalclearClearingBackUrl.GET_CLEARING_TASK_CHECK,  new SimpleRequest(taskId));
  }

}
